import { render, staticRenderFns } from "./ProjectPhotos.vue?vue&type=template&id=488d7c6e&"
import script from "./ProjectPhotos.vue?vue&type=script&lang=js&"
export * from "./ProjectPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports